export class Counter {
    public Angle: number;
    public Color: string;
    public Counter: number;
    public InitialCounter: number;
    public Name: string;
    public Poison: number;
}
